export interface OptionInterface {
  /**
   * 选项名
   */
  name?: string
  /**
   * 容量
   */
  volume?: number
  /**
   * 排序
   */
  weight?: number
  /**
   * 描述
   */
  description?: string
  /**
   * 关联活动任务 ID
   */
  activityTaskId: number
  /**
   * 已选容量
   */
  selectedVolume?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
}

export class Option implements OptionInterface {
  /**
   * 选项名
   */
  name?: string
  /**
   * 容量
   */
  volume?: number
  /**
   * 排序
   */
  weight?: number
  /**
   * 描述
   */
  description?: string
  /**
   * 关联活动任务 ID
   */
  activityTaskId: number
  /**
   * 已选容量
   */
  selectedVolume?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number

  constructor(props: OptionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      volume: _volume,
      weight: _weight,
      description: _description,
      activityTaskId: _activityTaskId,
      selectedVolume: _selectedVolume,
      id: _id,
      schoolId: _schoolId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.volume = _volume
    this.weight = _weight
    this.description = _description
    this.activityTaskId = _activityTaskId
    this.selectedVolume = _selectedVolume
    this.id = _id
    this.schoolId = _schoolId
  }
}
